export const searchIndex = [
  // Dashboard
  {
    title: "Main Dashboard",
    path: "/",
    category: "Dashboard",
    keywords: [
      "Total Users", "New Registrations Today", "Active Subscriptions", "Total Storage Used", "Active Offers", 
      "User Growth", "Global User Distribution", "Auth Providers", "Login Methods", "Top Countries (Logins)", 
      "Login Activity by Hour", "Top Login Apps", "User Demographics & Growth", "Geo-Location", 
      "Authentication & Security", "Storage Usage", "Content & Activity", "Revenue & Subscriptions", 
      "Recent Feedback", "Announcements", "overview", "analytics", "stats", "charts"
    ],
  },
  // Users
  {
    title: "Users List",
    path: "/users",
    category: "Users",
    keywords: [
      "Client", "Country", "Email", "Registration Date", "Device", "IP Address", "Subscriptions", 
      "Storage Usage", "Status", "clients", "customers", "profiles", "verification", "roles", "emails", 
      "Gender", "Referred By", "Auth Provider", "Created At", "Updated At"
    ],
  },
  {
    title: "User Analytics",
    path: "/users/analytics",
    category: "Users",
    keywords: [
      "User Growth", "Gender distribution", "Roles distribution", "Phone Numbers status", 
      "Verification status", "Referred By stats", "Register IP status", "Auth Provider distribution", 
      "Created At timestamps", "Updated At timestamps", "Monthly Users", "Daily Users", "demographics"
    ],
  },
  {
    title: "User Login Activity",
    path: "/activity",
    category: "Users",
    keywords: [
      "Login Activity", "User", "Last Login", "App Name", "Location", "Method", "Sessions", 
      "Register IP", "track record", "devices", "login time"
    ],
  },
  {
    title: "Login Analytics",
    path: "/activity/analytics",
    category: "Users",
    keywords: [
      "Total Sessions", "Login Methods", "Top Apps", "Top Countries", "Top Cities", "Top Users", 
      "Logins by Year", "Monthly Logins", "Daily Logins", "login trends", "hourly activity"
    ],
  },
  // {
  //   title: "Apps Activity Status",
  //   path: "/activity/status",
  //   category: "Users",
  //   keywords: ["coming soon", "status", "future updates", "apps activity"],
  // },
  // Subscriptions
  {
    title: "Subscription Overview",
    path: "/subscription",
    category: "Subscriptions",
    keywords: [
      "Total Subscriptions", "Active Subscriptions", "Monthly Recurring Revenue", "MRR", 
      "Annual Recurring Revenue", "ARR", "Average Revenue Per User", "ARPU", "New Subscriptions", 
      "Revenue Trends", "Top Products by Count", "Subscription Growth", "Recent Subscriptions", 
      "Subscriptions Status Distribution"
    ],
  },
  {
    title: "Subscription List",
    path: "/subscription/list",
    category: "Subscriptions",
    keywords: [
      "Plan", "User", "Amount", "Interval", "Start Date", "Status", "Billing Intervals", 
      "Total Revenue", "Top 3 Users", "Status Distribution", "Interval Distribution", "transactions"
    ],
  },
  {
    title: "Transactions",
    path: "/subscription/transaction",
    category: "Subscriptions",
    keywords: [
      "Total Transactions", "Successful Transactions", "Failed Transactions", "Refunded Transactions", 
      "Transaction Status", "Revenue by Product", "Transaction ID", "User", "Product", "Date", 
      "Amount", "Payment Method", "Status", "Receipt", "Email Receipt", "billing", "history"
    ],
  },
  // Location
  {
    title: "Location Overview",
    path: "/location",
    category: "Location",
    keywords: [
      "Total Locations (countries)", "Active Users", "New Users (past 30 days)", "Inactive Users", 
      "Location Map", "global distribution", "regions"
    ],
  },
  {
    title: "Country Management",
    path: "/location/country",
    category: "Location",
    keywords: [
      "Country List", "Client", "Country", "Email", "Reg. Date", "IP Address", "Status", 
      "states", "cities", "flags"
    ],
  },
  {
    title: "IP Address Overview",
    path: "/location/ip-address",
    category: "Location",
    keywords: [
      "Total IPs", "Unique IPs", "Total Countries", "Total Cities", "IP Map", "Top Countries", 
      "Top Cities", "network", "tracking"
    ],
  },
  {
    title: "IP Address List",
    path: "/location/ip-address/all",
    category: "Location",
    keywords: [
      "IP Address", "Location", "User Associated", "Last Access Time", "Activity", "Status", 
      "logins", "registrations", "flagged IPs"
    ],
  },
  // Storage
  {
    title: "Storage Dashboard",
    path: "/storage",
    category: "Storage",
    keywords: [
      "Storage Overview", "Total Files", "Total Folders", "Trashed Items", "Trash Size", 
      "Starred Items", "Shared Items", "Total Storage Capacity", "Total Used Storage", 
      "Active Users", "File Types", "Top Storage Consumers", "Top Products Used", "usage", "capacity"
    ],
  },
  {
    title: "User Storage List",
    path: "/storage/list",
    category: "Storage",
    keywords: [
      "Storage List", "User", "Used Storage", "Plan Type", "Plan Limit", "Verified", 
      "Storage Analytics", "Folders", "Files", "Earliest File", "Latest File", "Top File Types", "limits"
    ],
  },
  // Products
  {
    title: "Product Offers",
    path: "/products",
    category: "Products",
    keywords: [
      "Product Offers Management", "Name", "App Type", "Offer Slug", "Hero Title", "Created At", 
      "Status", "discounts", "promotions", "deals"
    ],
  },
  {
    title: "Subscription Plans",
    path: "/products/plans",
    category: "Products",
    keywords: [
      "Products Plans Management", "Plan Name", "Title", "Interval", "Amount", "App Type", 
      "Status", "Permissions", "Key", "Content", "Allowed Count", "Format/Unit", "Unlimited", 
      "pricing tiers", "features"
    ],
  },
  // Content
  {
    title: "Announcements",
    path: "/content",
    category: "Content",
    keywords: [
      "Announcements Management", "Total Announcements", "Active", "Inactive", 
      "Total Announcement views", "Name", "Text", "Page", "Color", "Click Action", 
      "Status", "Views", "Last Accessed", "news", "updates"
    ],
  },
  {
    title: "Limited Offers",
    path: "/content/offers",
    category: "Content",
    keywords: [
      "Limited Offers Bar Management", "Total Click", "Total Views", "Total Offers", 
      "Total Active", "Total Inactive", "Last Clicked", "Name", "Title", "Page", "CTA", 
      "End Time", "Views", "Clicks", "Last Viewed", "Last Clicked", "Status", "marketing", "coupons"
    ],
  },
  {
    title: "Blog Management",
    path: "/content/blogs",
    category: "Content",
    keywords: [
      "Blog Management", "Total Posts", "Published", "Drafts", "Total Views", 
      "Authors Management", "Title", "Author", "Category", "Status", "Published Date", 
      "Views", "slug", "excerpt", "content", "tags", "seo", "articles"
    ],
  },
  // Engagement
  {
    title: "Feedback",
    path: "/engagement",
    category: "Content",
    keywords: [
      "Feedback Management", "By App", "By Category", "By Month", "Time", "App", 
      "Category", "Content", "User Email", "User Details", "Status", "reviews", "ratings"
    ],
  },
];
